import { render, staticRenderFns } from "./CreateBlogPage.vue?vue&type=template&id=0c1592a2&scoped=true&"
import script from "./CreateBlogPage.vue?vue&type=script&lang=js&"
export * from "./CreateBlogPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateBlogPage.vue?vue&type=style&index=0&id=0c1592a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1592a2",
  null
  
)

export default component.exports